function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 4a3 3 0 11-6 0 3 3 0 016 0zm-3 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.64 11.98l-.983 1.31a.5.5 0 00-.074.459l1.027 3.082c.072.215.39.163.39-.064V12.1a.2.2 0 00-.36-.12zM18.36 11.98l.983 1.31a.5.5 0 01.074.459L18.39 16.83c-.072.215-.39.163-.39-.064V12.1a.2.2 0 01.36-.12z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.773 9.664a2.75 2.75 0 012.404-1.414h5.646a2.75 2.75 0 012.404 1.414l1.436 2.584a2.75 2.75 0 01.092 2.488l-2.513 5.447-.493 9.855a.75.75 0 01-.75.712h-1.5a.75.75 0 01-.736-.612L16 26.07l-.763 4.068a.75.75 0 01-.737.612H13a.75.75 0 01-.75-.712l-.492-9.855-2.514-5.447a2.75 2.75 0 01.093-2.488l1.436-2.584zm2.404.086a1.25 1.25 0 00-1.093.643l-1.435 2.584a1.25 1.25 0 00-.043 1.13l2.575 5.579a.75.75 0 01.068.276l.464 9.288h.165l1.385-7.388a.75.75 0 011.474 0l1.385 7.388h.165l.464-9.288a.75.75 0 01.068-.276l2.575-5.578a1.25 1.25 0 00-.043-1.131l-1.435-2.584a1.25 1.25 0 00-1.093-.643h-5.646z",
  fill: "currentColor"
})));